// stores/sessionManager.js
import { writable } from 'svelte/store';
import { auth } from './auth';

function createSessionManager() {
  // We've simplified the state to just what we need
  const initialState = {
    showSessionModal: false,
    lastError: null,
    isInitialized: false
  };

  const { subscribe, set, update } = writable(initialState);
  let store;

  subscribe(value => {
    store = value;
  });

  return {
    subscribe,

    handleSessionExpired(error) {
      if (!store?.isInitialized) {
        throw new Error('Session manager not initialized');
      }

      // Clear any existing auth state
      auth.reset();
      
      // Show the modal immediately
      update(state => ({
        ...state,
        showSessionModal: true,
        lastError: error
      }));
    },

    closeSessionModal() {
      update(state => ({
        ...state,
        showSessionModal: false,
        lastError: null
      }));
    },

    reset() {
      set({
        ...initialState,
        isInitialized: true
      });
    },

    init() {
      update(state => ({
        ...state,
        isInitialized: true
      }));
    }
  };
}

export const sessionManager = createSessionManager();

// Initialize if we're in the browser
if (typeof window !== 'undefined') {
  sessionManager.init();
}